import { useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { axios } from 'configurations/axios';
import { CziGetResponse } from '../models/CziGetResponse';

export const useGetCziByWellId = (wellId: string | undefined) => {
    const { tenantConfig, jwt } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
        jwt: state.jwtToken
    }));

    return useQuery<CziGetResponse>(
        ['GetCzi', wellId],
        async () => {
            const response = await axios.get<IResponseAPI<CziGetResponse>>(
                `${tenantConfig?.endpoints.dataApi}/Czi/Get`,
                {
                    params: {
                        wellId: wellId
                    },
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data.Result;
        },
        {
            enabled: !!wellId && !!tenantConfig?.endpoints.dataApi
        }
    );
};
